import { ROUTES } from '../../const/routes';

const ImagenTragamonedasInicio = () => {
  return (
    <img
      src={ROUTES.rutaIlustraciones + 'Tragamonedas01Resized.gif'}
      alt="Logo Casino Print"
      className="h-80 sm:h-[22rem] md:h-96 my-auto drop-shadow-[0_0_20px_rgba(56,189,248,0.7)] transition-all duration-300 ease-in-out hover:drop-shadow-[0_0_30px_rgba(56,189,248,0.9)]"
    />
  );
};

export default ImagenTragamonedasInicio;
